import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"w-full\"><div class=\"w-full mb-5\"><div class=\"w-full h-4 mb-2 skeleton-unit\"></div><div class=\"w-full h-4 mb-2 skeleton-unit\"></div><div class=\"w-full h-4 mb-2 skeleton-unit\"></div></div><div class=\"w-4/5 h-3 mb-2 skeleton-unit\"></div><div class=\"w-4/5 h-3 mb-2 skeleton-unit\"></div><div class=\"w-4/5 h-3 mb-2 skeleton-unit\"></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}